import React from "react";
import { SpinnerIcon, ArrowRightIcon } from "../icons";

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
  isValid: boolean;
  isLoading: boolean;
  onPrev?: () => void;
  onNext: () => void;
  onCancel: () => void;
  nextButtonText?: string;
  prevButtonText?: string;
  cancelButtonText?: string;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentStep,
  totalSteps,
  isValid,
  isLoading,
  onPrev,
  onNext,
  onCancel,
  nextButtonText = "Dalej",
  prevButtonText = "Wstecz",
  cancelButtonText = "Anuluj",
}) => {
  return (
    <div className="pt-2 border-neutral-100">
      <div className="flex justify-between">
        {onPrev ? (
          <button type="button" onClick={onPrev} className="btn-secondary">
            {prevButtonText}
          </button>
        ) : (
          <button type="button" onClick={onCancel} className="btn-secondary">
            {cancelButtonText}
          </button>
        )}

        <button
          type="submit"
          disabled={!isValid || isLoading}
          className="btn-primary"
        >
          {isLoading ? (
            <span className="flex items-center">
              <SpinnerIcon className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" />
              Zapisywanie...
            </span>
          ) : isValid ? (
            <span className="flex items-center justify-center">
              {nextButtonText}
              <ArrowRightIcon className="ml-2 w-5 h-5" />
            </span>
          ) : (
            "Wypełnij wymagane pola"
          )}
        </button>
      </div>
    </div>
  );
};

export default ProgressIndicator;
